import Vue from 'vue';
import {gsap, CSSPlugin, Power2} from 'gsap';
import cateringForm from '../partials/modules/catering-form.vue';
import CateringForm from "../partials/modules/catering-form.vue";

gsap.registerPlugin(CSSPlugin);

export default {
    init() {
        const app = new Vue({
            el: '#catering',

            components: {
                cateringForm
            },

            data: {
                started: false
            },

            mounted() {
                const tl = gsap.timeline();

                tl.set(this.$refs.title, { opacity: 0, y: '104%' })
                    .set(this.$refs.subtitle, { opacity: 0, y: '104%' })
                    .set(this.$refs.button, { opacity: 0, y: '104%' })
                    .to(this.$refs.title, 0.6, { opacity: 1, y: '0%', delay: 0.4, ease: Power2.easeInOut })
                    .to(this.$refs.subtitle, 0.6, { opacity: 1, y: '0%', delay: -0.4, ease: Power2.easeInOut })
                    .to(this.$refs.button, 0.6, { opacity: 1, y: '0%', delay: -0.4, ease: Power2.easeInOut });
            },

            methods: {
                start() {
                    this.started = true;
                    $('.site-header').fadeOut();
                }
            }
        });

        document.getElementById('footer-toggle').addEventListener('click', ev => {
            ev.preventDefault();
            app.start();
        });
    },
    finalize() {}
};
